import { unpackExternalResource } from "@b2bportal/core-types";
import { createSelector } from "@reduxjs/toolkit";
import type { CarsState } from "../../../../store";

export const getCarShop = createSelector(
  (state: CarsState) => state.cars.carsShop.response,
  (shopResponse) => {
    return unpackExternalResource(shopResponse);
  }
);

export const getSelectedVehicle = (state: CarsState) =>
  state.cars.carsShop.selectedVehicle;

export const getCarShopData = (state: CarsState) =>
  state.cars.carsShop.response.data;
